module.exports = __webpack_public_path__ + "img/1559581654.e07ccc13.jpg";